import React, { Component } from "react";

import { BrowserRouter as Router, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";

import Crypto from "./pages/Crypto";
import Kuznechik from "./pages/Kuznechik";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "./containers/Footer/Footer";
import { ToastContainer } from "react-toastify";
import Header from "./containers/Header/Header";

class App extends Component {
  constructor() {
    super()
  }

  render() {
    return (
      <Provider store={store}>
        <Router>
          <div >
            {/* <TopBar logout={this.logout}/> */}
            <div id="wrapper">
              <Header />
              <Route path="/" exact component={Crypto} />
              <Route path="/cryptokuznechik" exact component={Kuznechik} />
              {/* <Route path="/privacy_policy.pdf" component={DownloadPDF} /> */}

              {/* <RouteWithProps path='/login' component={LoginPage} props={{ login: this.login }} />
              <RouteWithProps path='/notloggedin' component={LoginPage} props={{ login: this.login }} /> */}
              <Footer />
            </div>
          </div>
          <ToastContainer />
        </Router>
      </Provider>
    );

  }

}

export default App;
